/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGINFIRMIERInner { 
    /**
     * EF_EP409.22 Données à caractère médical. Donnée alimentée par le PS ou le LPS(1).
     */
    DCM?: string;
    Detail: string;
    /**
     * EF_EP409.04 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportALD: boolean;
    /**
     * EF_EP409.05 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportAccident: boolean;
    /**
     * EF_EP409.06 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportPrev: boolean;
    /**
     * EF_EP409.08 Hors nomenclature. Donnée alimentée par le PS ou le LPS(1).
     */
    EstHN: boolean;
    /**
     * EF_EP409.07 Non remboursable. Donnée alimentée par le PS ou le LPS(1).
     */
    EstNonRemb: boolean;
    NumLigne: number;
}

